import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import R1LevelAnalyticsView from "@/features/R1Dashboard/views/R1LevelAnalyticsView";

export default function R1LevelAnalytics() {
  useEffect(() => {
    setDocumentTitle("Quantilia | R1 Level");
  }, []);

  return (
    <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
      <R1LevelAnalyticsView />
    </main>
  );
}
